import type { CSSProperties } from 'react'

import type { BlueprintFrameModifier } from '@/grove-blueprints/generated-types'

export function resolveFrameModifier(
  modifier: BlueprintFrameModifier,
): CSSProperties {
  const style: CSSProperties = {}

  if (modifier.width !== undefined) {
    style.width = modifier.width
  }

  if (modifier.height !== undefined) {
    style.height = modifier.height
  }

  if (modifier.aspectRatio !== undefined) {
    // @ts-ignore: This project has an outdated type definition for aspectRatio; 'number' is valid.
    style.aspectRatio = modifier.aspectRatio
  }

  return style
}
